import React from 'react';
import { sideOvers, sideRuns } from '@/lib/cricket';

// One side's cricket score: bold "192/4" with "(18.4 Overs)" beside it (or below it when stacked).
export const CricketScore = ({ match, side, className = '', testId, stacked = false }) => {
  const runs = sideRuns(match, side);
  const overs = sideOvers(match, side);
  if (!runs) return null;
  return (
    <span className={`whitespace-nowrap ${stacked ? 'inline-flex flex-col items-center leading-tight' : ''} ${className}`} data-testid={testId}>
      {runs}
      {overs && <span className={`${stacked ? '' : 'ml-1 '}font-sans text-[11px] font-normal text-slate-500`}>({overs} Overs)</span>}
    </span>
  );
};
